import Rails from "@rails/ujs";
window.Rails = Rails;
Rails.start();

import * as Turbo from "@hotwired/turbo";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();

import Trix from "trix"
import "@rails/actiontext";
import "@thoughtbot/trix-mentions-element";
window.Trix = Trix;

// https://alpinejs.dev/upgrade-guide#need-to-call-alpine-start
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.default.css';
window.TomSelect = TomSelect;
document.querySelectorAll('.tom-select').forEach((el) => new TomSelect(el));

// register service workers
import '../src/service-worker.js';

// semantic-ui
import '../semantic-ui/dist/semantic.min.css';
import '../semantic-ui/dist/semantic.min.js';

// styles
import '../src/general.scss';

import 'trix/dist/trix.css';
import '../src/actiontext.scss';
import '../src/responsive.scss';
import '../src/main_navigation.scss';

// dark mode should be loaded last so that it can override earlier styles more easily
import '../src/darkmode.scss';

// stimulus
import '../src/stimulus.js';

// initializers and custom components
import '../src/beforeunload.js';
import '../src/click-to-copy.js';
import '../src/localtime.js';
import '../src/keyboard-shortcuts.js';
import '../src/semantic-ui.js';
import '../src/main_navigation.js';
import '../src/sortable.js';
import '../src/tablesort.js';
import '../src/login_form.js';
import '../src/color_scheme.js';
import '../src/webauthn.js';
import '../src/webmcp.js';
import '../src/dashboard.js';
import '../src/dashboard.scss';

// image assets
const images = require.context('../src/images', true)
const imagePath = (name) => images(name, true)
